import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, {
	type EmblaCarouselType,
	EmblaOptionsType,
} from 'embla-carousel'
import {TsDOM as q} from '@/scripts/core/TsDOM'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'
import AutoHeight from 'embla-carousel-auto-height'
import Autoplay from 'embla-carousel-autoplay'
import Fade from 'embla-carousel-fade'
import { addThumbBtnsClickHandlers, addToggleThumbBtnsActive } from '@/scripts/core/embla-functions'

export class TestimonialsSlider extends UcoastEl {
	static htmlSelector = 'testimonials-slider'
	autoRotate: boolean
	speedInSeconds?: string
	emblaApiMain?: EmblaCarouselType
	emblaApiThumb?: EmblaCarouselType
	constructor() {
		super()
		this.autoRotate = this.hasAttribute('data-embla-auto')
		this.speedInSeconds = q.oa(
			this,
			'data-speed-seconds'
		)
	}

	override connectedCallback() {
		super.connectedCallback()
		this.initSlider()
	}

	initSlider() {
		const OPTIONS: EmblaOptionsType = {
			inViewThreshold: 1,
			align: 'center',
			containScroll: false,
			duration: 10,
			loop: true,
		}
		const OPTIONS_THUMBS: EmblaOptionsType = {
			containScroll: 'keepSnaps',
			dragFree: true,
			align: 'start',
			breakpoints: {
				'(min-width: 750px)': { align: 'center' },
			},
		}
		const viewportNode = q.rs('.embla__viewport', this)
		const viewportNodeThumbCarousel = <HTMLElement>(
			document.querySelector('.embla-thumbs__viewport')
		)
		this.emblaApiMain = this.autoRotate
			? EmblaCarousel(viewportNode, OPTIONS, [
					WheelGesturesPlugin(),
					ClassNames(),
					AutoHeight(),
					Autoplay({ jump: true }),
					Fade(),
				])
			: EmblaCarousel(viewportNode, OPTIONS, [
					WheelGesturesPlugin(),
					ClassNames(),
					AutoHeight(),
					Fade(),
				])

		this.emblaApiThumb = EmblaCarousel(
			viewportNodeThumbCarousel,
			OPTIONS_THUMBS
		)
		const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
			this.emblaApiMain,
			this.emblaApiThumb
		)
		const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
			this.emblaApiMain,
			this.emblaApiThumb
		)

		this.emblaApiMain
			.on('destroy', removeThumbBtnsClickHandlers)
			.on('destroy', removeToggleThumbBtnsActive)

		this.emblaApiThumb
			.on('destroy', removeThumbBtnsClickHandlers)
			.on('destroy', removeToggleThumbBtnsActive)
			.on('init', () => {
				window.setTimeout(() => {
					void window.Ucoast.mediaManager.playAllInContainer(this)
				}, 3)
			})

		this.classList.remove('loading')
	}
	override animateIn() {
		super.animateIn()
		this.play()
	}
	override animateOut() {
		super.animateOut()
		this.pause()
	}
	play() {
		this.emblaApiMain?.plugins()?.autoplay?.play()
	}
	pause() {
		this.emblaApiMain?.plugins()?.autoplay?.stop()
	}
}

